import { OnInit, Component, ViewChild  } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { VendorService } from '../../../services/vendorservice';
import { ToastrService } from 'ngx-toastr';
import { PharmacyCRUDModel } from '../../DTO/pharmacy-crud';
import { formatDate } from "@angular/common";
import {MatExpansionModule} from '@angular/material/expansion';
import { ConnectionDetails } from '../../DTO/pharmacy';

import { Vendor } from '../../DTO/vendor';
import { ConnectionDetailsComponent } from '../../connection/connection-details/connection-details.component';

@Component({
  selector: 'app-vendor-add',
  templateUrl: './vendor-add.component.html',
  styleUrls: ['./vendor-add.component.css']
})
export class VendorAddComponent implements OnInit {
  isLoading: boolean = false;
  form: FormGroup;

  VendorName: FormControl;

  vendorList: Vendor[] = [];

  pharmacyModel: PharmacyCRUDModel;
  useOkta:boolean=false;
  userName: string='';
  minEffectiveDate:Date=new Date();
  minTermDate:Date=new Date();
  panelOpenState = false;
  connectionMessage:string='';
  missingParameter = false;
  isConnectionSuccessful = false;
  UseConnectionDetails: FormControl;
  vendor: Vendor = new Vendor();

  connectionDetailsAttributeModel: any = {};

  @ViewChild(ConnectionDetailsComponent) connectionDetailsComponent: ConnectionDetailsComponent;


  constructor(private vendorService: VendorService, private toastr:ToastrService,
    private router: Router) {
     
  }

  ngOnInit() {
        this.vendor.AuthType = "BASIC";
    this.vendor.VendorEndpointURL = this.vendor.VendorEndpointURL || "";
    this.minTermDate.setDate(new Date().getDate()+1);
    this.createFormControls();
    this.createForm();

    this.vendorService.getVendors();

    // this.transactionservice.getTransactionGrid(this.vendors)
    //     .subscribe(res => {
    //       res.transactionData.forEach((transactionModel: any)=> {
    //         transactionArray.push(
    //         {
    //           "Message Id":transactionModel.MessageID,
    //           "Relates To Message Id":transactionModel.RelatesToMessageID,
    //           "Pharmacy Chain Name":transactionModel.PharmacyName,
    //           "Patient Last Name":transactionModel.PatientLastName,
    //           "Patient DOB":transactionModel.PatientDOB,
    //           "Species":transactionModel.Species,
    //           "Message Type":transactionModel.MessageType,
    //           "Transaction Date and Time":transactionModel.RequestDate,
    //           "Transaction Status":transactionModel.ResponseStatus,
    //           "Initiator":transactionModel.Initiator,
    //         })
    //        });
    this.userName = localStorage.getItem("loggedName");


  }
  
  createFormControls() {
    this.VendorName = new FormControl('', [Validators.required, Validators.maxLength(60)]);
    this.UseConnectionDetails = new FormControl(false);
  }

  createForm() {
    this.form = new FormGroup({
      VendorName: this.VendorName,
      UseConnectionDetails: this.UseConnectionDetails
    });
  }

  get errorMessageForVendorName(): string {
    const vendorform: FormControl = (this.form.get('VendorName') as FormControl);
    return vendorform.hasError('required') ?
      'Vendor name is required' :
      vendorform.hasError('maxlength') ?
      'Max length is 60 characters' :
      vendorform.hasError('duplicate') ?
      'Vendor already exists' :"" 
  }

  clearVendorNameDuplicateValidation(){
    this.VendorName.setErrors({'duplicate': null});
    this.VendorName.updateValueAndValidity();
  }


  OnVendorChange(event:any) {
    this.clearVendorNameDuplicateValidation();
  }

  submitForm(){
    if (this.form.valid) {

      if(this.connectionDetailsComponent.panelOpenState) {
        this.vendor.IsConnectivitySet = "true";
        this.connectionDetailsComponent.setModelAttributes();
      } else {
        this.vendor = new Vendor();
        this.vendor.IsConnectivitySet = "false";
      }

      this.vendor.VendorName = this.form.get('VendorName')?.value;
      this.vendor.UpdatedBy = localStorage.getItem("loggedName");
      this.isLoading = true;
      // if((this.OktaMckClientId.value??"")=="" || 
      // (((this.BasicUserName.value??"")=="" || (this.BasicPassword.value??"")=="") &&
      // ((this.OktaAuthURL.value??"")=="" || (this.OktaClientId.value??"")=="" || (this.OktaClientSecret.value??"")==""))){
      //   this.toastr.warning('Pharmacy connection details not available for all fields');
      // }
      this.vendorService.addVendor(this.vendor).subscribe(res => {
        this.isLoading = false;
        console.log(res.ResponseStatus);
        if(res.ResponseStatus=='1'){
          this.toastr.success('Vendor saved successfully');
          this.router.navigate(['searchvendor']);
        }
        else if(res.ResponseStatus=='0' && res.ResponseMessage!=''){
          this.toastr.error(res.ResponseMessage);
        }
      },(error: any)=>{
        this.isLoading=false;
        if(Array.isArray(error)){
          for (var err of error){
            if(err.ErrorMessage=='Vendor Duplicate'){
              this.VendorName.setErrors({'duplicate': true});
              // this.form.get('VendorName')?.markAsTouched();
            }
          }
        }
        else if(error=='Vendor Duplicate'){
          this.VendorName.setErrors({'duplicate': true});
          // this.form.get('VendorName')?.markAsTouched();
        }
        else{
          this.toastr.error(error);
        }
      });
    }
  }

  // getPharmacyModel(){
  //   this.pharmacyModel=new PharmacyCRUDModel();
  //   this.pharmacyModel.PharmacyName = this.form.get('VendorName')?.value;

  //   this.pharmacyModel.PharmacyEndpointURL = this.form.get('PharmacyEndpointURL')?.value;
  //   this.pharmacyModel.OktaMckClientId = this.form.get('OktaMckClientId')?.value;
  //   this.pharmacyModel.AuthType = this.form.get('AuthType')?.value;
  //   if(this.pharmacyModel.AuthType=="OKTA") {
  //     this.pharmacyModel.OktaAuthURL = this.form.get('OktaAuthURL')?.value;
  //     this.pharmacyModel.OktaClientId = this.form.get('OktaClientId')?.value;
  //     if(this.form.get('OktaClientSecret')?.value)
  //       this.pharmacyModel.OktaClientSecret = btoa(this.form.get('OktaClientSecret')?.value);
  //     //this.pharmacyModel.OktaClientSecret = this.form.get('OktaClientSecret')?.value;
  //   }
  //   else {
  //     if(this.form.get('BasicUserName')?.value)
  //       this.pharmacyModel.BasicUserName = btoa(this.form.get('BasicUserName')?.value);
  //     if(this.form.get('BasicPassword')?.value)
  //       this.pharmacyModel.BasicPassword = btoa(this.form.get('BasicPassword')?.value);
  //     // this.pharmacyModel.BasicUserName = this.form.get('BasicUserName')?.value;
  //   }
  //   // this.pharmacyModel.BasicPassword = this.form.get('BasicPassword')?.value;
  //   this.pharmacyModel.UpdatedBy=this.userName;
  // }

  onClickCancel(){
    this.router.navigate(['home']);
  }

  // testConnection(){
  //   this.missingParameter = false;
  //   this.connectionDetails =new ConnectionDetails();
  //   this.connectionDetails.AuthType = this.form.get('AuthType')?.value;
  //   this.connectionDetails.EndpointURL = this.form.get('PharmacyEndpointURL')?.value;
  //   if(this.connectionDetails.EndpointURL == "")
  //     this.missingParameter = true;
  //   if(this.connectionDetails.AuthType=="OKTA") {
  //     this.connectionDetails.AuthURL = this.form.get('OktaAuthURL')?.value;
  //     this.connectionDetails.ClientID = this.form.get('OktaClientId')?.value;
  //     this.connectionDetails.ClientSecret = this.form.get('OktaClientSecret')?.value;
  //     if(this.connectionDetails.AuthURL == "" || this.connectionDetails.ClientID == "" || this.connectionDetails.ClientSecret == "")
  //       this.missingParameter = true;
  //   }
  //   else {
  //     this.connectionDetails.UserName = this.form.get('BasicUserName')?.value;
  //     this.connectionDetails.Password = this.form.get('BasicPassword')?.value;
  //     if(this.connectionDetails.UserName == "" || this.connectionDetails.Password == "")
  //       this.missingParameter = true;
  //   }

  //   if(this.missingParameter) {
  //     this.isConnectionSuccessful = false;
  //     this.connectionMessage = 'Connectivity Failed: A parameter is missing';
  //   }
  //   else {
  //     this.vendorService.testConnection(this.connectionDetails).subscribe(res => {
  //       this.isLoading = false;
  //       if(res.ResponseStatus=='1'){
  //         this.isConnectionSuccessful = true;
  //         this.connectionMessage = 'Connectivity Success';
  //       }
  //       else if(res.ResponseStatus=='0' && res.ResponseMessage!=''){
  //         this.isConnectionSuccessful = false;
  //         this.connectionMessage = res.ResponseMessage;
  //       }
  //     }
  //   )}
  // }
}


